<ng-container>
    @if (loaderService.isLoading()) {
        <div class="load-container">
            <img alt="logo" ngSrc="assets/images/adaa-loader.gif" width="200" height="200" priority />
        </div>
    }
</ng-container>
